import { useState } from "react";
import { getBlob } from "../lib/api.js";
import { useToast } from "../lib/toast.js";
import { errorMessage } from "../lib/useQuery.js";
import { Button } from "./ui.js";

/**
 * Captura's «Vista previa»: opens the report as it would print from the values already SAVED, in a
 * new tab, stamped "VISTA PREVIA — SIN VALIDAR" by the server (no signature, nothing stored, not
 * deliverable). Values typed but not saved are not in it, so the button says so while the screen
 * holds unsaved changes.
 */
export function DraftPreviewButton({ orderId, dirty, disabled = false }: { orderId: string; dirty: boolean; disabled?: boolean }) {
  const toast = useToast();
  const [busy, setBusy] = useState(false);

  async function open() {
    // The tab opens synchronously, in the click, so a popup blocker lets it through.
    const tab = window.open("", "_blank");
    setBusy(true);
    try {
      const blob = await getBlob("orderDraftPreviewPdf", { params: { id: orderId }, query: { letterhead: true } });
      const url = URL.createObjectURL(blob);
      if (tab) tab.location.href = url;
      else window.open(url, "_blank");
      setTimeout(() => URL.revokeObjectURL(url), 5 * 60_000);
    } catch (e) {
      tab?.close();
      toast.error(errorMessage(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <span className="row" style={{ gap: 8 }}>
      {dirty && <span className="muted small">Guarda para verlos en la vista previa</span>}
      <Button variant="ghost" icon="quote" busy={busy} disabled={disabled || busy} onClick={() => void open()} title="Abre el informe con los resultados guardados, sin validar">
        Vista previa
      </Button>
    </span>
  );
}
